import { baseService } from "cortex/ui/src/service/base";

export const accountStatsService = {
  loadByDate(date: string) {
    return baseService.get(`/api/account/stats/${date}`);
  },

  loadByAccount(accountId: string | number) {
    return baseService.get(`/api/account/${accountId}/stats`);
  },
};

export default accountStatsService;
